import { render } from "@/components/pages/immobilizer/imbRegCombinationMeterType2/ImbRegCombinationMeterType2.html?vue&type=template&id=0118e930&external"
import script from "@/components/pages/immobilizer/imbRegCombinationMeterType2/ImbRegCombinationMeterType2.js?vue&type=script&lang=js&external"
export * from "@/components/pages/immobilizer/imbRegCombinationMeterType2/ImbRegCombinationMeterType2.js?vue&type=script&lang=js&external"

import "@/components/pages/immobilizer/imbRegCombinationMeterType2/ImbRegCombinationMeterType2.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__